import React from "react";
import "./pageEmptySpace.css";

const PageEmptySpace = (props) => {
    const {
        classEmpty = 'AppPageEmptySpace',
        data = {
            slogan: "Elakay works for",
            text: ["Art Lovers", "Trend Seekers", "Smart Shoppers", "YOU!"]
        }
    } = props;

    return (
        <div className={`page-empty-space ${classEmpty}`}>
            <p className="empty-slogan">{data.slogan}</p>
            <div className="dropping-texts">
                {data.text?.map((text, index) => (
                    <div
                        key={index}
                        className="drop-text-item"
                        style={{ animationDelay: `${index * 0.3}s` }}
                    >
                        {text}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PageEmptySpace;
